export default __webpack_public_path__ + "static/media/arrow_back_gray.4ae88adc.svg";